/* eslint-disable no-nested-ternary */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import TableGrid from '../../../../../SharedModules/Table/TableGridWithFeatures';
import * as serviceEndPoint from '../../../../../SharedModules/services/service';
import {
  clientTableHead,
  rebateProgramTableHead,
  superClientTableHead,
  groupTableHead,
  superClientModalHead,
} from './tableHead';
import ModalDialog from '../../../../../SharedModules/Dialog/ModalDialog';
import {
  dispatchErrorMessages,
  setClientSearchDataAction,
  setReduxDataIntoSearchScr,
  setTabValue,
} from '../../store/actions';
import ClientSearchCriteria from './clientSearchCriteria';
import Spinner from '../../../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  dispatchContactDetailsClient,
  setIsValidContactForm,
} from '../../../Plan/store/actions';
import ViewHistoryComponent from '../../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import { DOUBLE_CLICK_GRID_MSG } from '../../../../../SharedModules/Errors/constantMessageData';
import { redirectURLLink } from '../../../../../SharedModules/CommonUtilities/commonUtilities';

const SearchClient = (props) => {
  const clientSearchData = useSelector((state) => {
    return state.sharedState.ClientReducer.clientSearchData;
  });
  const reduxDataSearchScreen = useSelector((state) => {
    return state.sharedState.ClientReducer.searchScreenData;
  });
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const gridRef = useRef(0);
  const [multiGroup, setMultiGroup] = useState({
    open: false,
    rowData: null,
    tableData: [],
  });
  const [totalCount, setTotalCount] = useState(0);
  const [selectedClient, setSelectedClient] = useState(
    reduxDataSearchScreen?.state?.selectClient || 'Client'
  );
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = useState(false);
  const [keyValue, setKeyValue] = useState([]);
  const [showViewHistory, setShowViewHistory] = useState(false);

  const setClientSearchDatInRedux = (data) => {
    dispatch(setClientSearchDataAction(data));
  };
  // handing by default first row selection function
  const onGridReady = (params) => {
    params.api.forEachNode(
      (node) =>
        node.rowIndex === reduxDataSearchScreen?.currentIndex &&
        node.setSelected(true)
    );
  };
  const handleViewHistory = (gridApi) => {
    const selectedRow = gridApi.getSelectedRows()?.[0]?.dispSeqNum;
    if (selectedRow !== undefined) {
      setShowViewHistory(true);
      setKeyValue({ DISP_SEQ_NUM: selectedRow });
    }
  };

  useEffect(() => {
    if (selectedClient === 'Rebate Program Code') {
      getRebateProgram();
    } else if (selectedClient === 'Super Client') {
      getSuperClients();
    } else if (selectedClient === 'Client') {
      getClients();
    } else {
      getGroups();
    }
  }, [selectedClient]);

  useEffect(() => {
    if (gridRef?.current?.api && setTotalCount) {
      const count = gridRef?.current?.api?.getDisplayedRowCount();
      setTotalCount(count);
    }
  });

  const getClients = () => {
    axios
      .post(serviceEndPoint.GET_ALL_CLIENTS, { route: 'getAllClients' })
      .then((response) => {
        const data = response?.data?.data;
        const numbers = data?.filter(
          (element) => !isNaN(element.clientId.trim())
        );
        const strings = data?.filter((element) =>
          isNaN(element.clientId.trim())
        );
        setClientSearchDatInRedux(
          data && data.length > 0 ? [...numbers, ...strings] : []
        );
      })
      .catch(() => {
        setClientSearchDatInRedux([]);
      });
  };

  const getRebateProgram = () => {
    axios
      .post(serviceEndPoint.GET_ALL_CLIENTS, { route: 'getAllRebatePrograms' })
      .then((response) => {
        const data = response?.data?.data;
        setClientSearchDatInRedux(data && data.length > 0 ? data : []);
      })
      .catch(() => {
        setClientSearchDatInRedux([]);
      });
  };

  const getSuperClients = () => {
    axios
      .post(serviceEndPoint.GET_ALL_CLIENTS, { route: 'getAllSuperClients' })
      .then((response) => {
        const data = response?.data?.data;
        const numbers = data.filter(
          (element) => !isNaN(element.superClientName.trim())
        );
        const strings = data.filter((element) =>
          isNaN(element.superClientName.trim())
        );

        setClientSearchDatInRedux(
          data && data.length > 0 ? [...numbers, ...strings] : []
        );
      })
      .catch(() => {
        setClientSearchDatInRedux([]);
      });
  };

  const getGroups = () => {
    axios
      .get(serviceEndPoint.GET_ALL_GROUPS)
      .then((response) => {
        const data = response?.data?.data;
        const numbers = data?.filter(
          (element) => !isNaN(element.groupId.trim())
        );
        const strings = data?.filter((element) =>
          isNaN(element.groupId.trim())
        );
        setClientSearchDatInRedux(
          data && data.length > 0
            ? [...numbers, ...strings]?.map((item) => {
                return { ...item, groupId: item.groupId.trim() };
              })
            : []
        );
      })
      .catch(() => {
        setClientSearchDatInRedux([]);
      });
  };

  const closeMultiGroup = (value) => {
    if (value) {
      setMultiGroup({ ...multiGroup, open: value });
    } else {
      setMultiGroup({ open: value, rowData: null, tableData: [] });
    }
  };

  const onCellClickedListener = (e) => {
    redirectToMaintain(e.data.clientId);
  };

  const redirectToMaintain = (clientId) => {
    window.localStorage.setItem('clientId', clientId);
    window.localStorage.setItem('clientSearchOrAdd', 'search');
    dispatch(setTabValue(0));
    dispatch(dispatchErrorMessages([]));
    redirectURLLink('/maintain', 'Maintain Client', props.history, dispatch);
  };

  const getAllGroupByRebateProgramCode = (rowData) => {
    const rebateProgramId = rowData?.rebateProgramCd;
    axios
      .post(serviceEndPoint.GET_CLIENT_BY_REBATE_PROGRAM_CD, {
        rebateProgramCd: rebateProgramId,
      })
      .then((response) => {
        if (response.data && response.data) {
          if (response.data.length > 1) {
            const popupData = response.data.map((x) => {
              return { clientId: x.cgpId?.clientId, clientName: x.clientName };
            });
            setMultiGroup({ open: true, rowData, tableData: popupData });
          } else {
            const data = response.data[0];
            const clientId = data?.cgpId?.clientId;
            redirectToMaintain(clientId);
          }
        }
      })
      .catch(() => {});
  };

  const getGroupDetails = (rowData) => {
    const groupId = rowData?.groupId;
    axios
      .post(serviceEndPoint.GET_CLIENT_BY_GROUP, { groupId: groupId })
      .then((response) => {
        if (response.data) {
          if (response.data.length > 1) {
            const popupData = response.data.map((x) => {
              return { clientId: x.clientId, clientName: x.clientName };
            });
            setMultiGroup({ open: true, rowData, tableData: popupData });
          } else {
            const data = response.data[0];
            const clientId = data?.clientId;
            redirectToMaintain(clientId);
          }
        }
      })
      .catch(() => {});
  };

  const onSuperCellClicked = (rowData) => {
    const superClientName = rowData?.superClientName;
    axios
      .post(serviceEndPoint.GET_ALL_CLIENTS, {
        route: `getClientsBySuperClient?superClientName=${superClientName}`,
      })
      .then((response) => {
        if (response?.data?.data) {
          const superClientData = response?.data?.data;
          if (superClientData.length > 1) {
            const popupData = superClientData.map((x) => {
              return { clientId: x.clientId, clientName: x.clientName };
            });
            setMultiGroup({ open: true, rowData, tableData: popupData });
          } else {
            const data = superClientData[0];
            const clientId = data?.clientId;
            redirectToMaintain(clientId);
          }
        }
      })
      .catch(() => {});
  };

  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  return (
    <div className="tabs-container">
      <ModalDialog
        open={multiGroup?.open}
        closeModal={closeMultiGroup}
        grid={
          <TableGrid
            isModalTable
            gridHeight="270px"
            rowData={multiGroup?.tableData}
            defaultCol={{ editable: false }}
            columnDefs={superClientModalHead}
            cellClickedListener={onCellClickedListener}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            handleViewHistory={handleViewHistory}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            exportFile
            data-testid="onEditingStopped"
            fileName="Client_rebate"
            helpMessage={DOUBLE_CLICK_GRID_MSG}
          />
        }
        totalCount={totalCount}
        dialogTitle="Choose a Client"
        cancelAction={closeMultiGroup}
      />
      <Spinner load={spinnerLoader} />
      <CustomSeparator parent1="Maintain" parent2="Client" />
      {!fullScreenView && (
        <>
          <ClientSearchCriteria
            setSelectedClient={setSelectedClient}
            fullScreenView={fullScreenView}
            setFullScreenView={setFullScreenView}
            selectedClient={selectedClient}
          />
          <div className="devider-line pb-4" />
        </>
      )}
      <TableGrid
        ref={gridRef}
        gridCall={onGridReady}
        rowData={clientSearchData}
        defaultCol={{ editable: false }}
        columnDefs={
          selectedClient === 'Rebate Program Code'
            ? rebateProgramTableHead
            : selectedClient === 'Client'
            ? clientTableHead
            : selectedClient === 'Super Client'
            ? superClientTableHead
            : groupTableHead
        }
        cellClickedListener={(e) => {
          dispatch(
            setReduxDataIntoSearchScr({
              ...reduxDataSearchScreen,
              currentIndex: e?.rowIndex,
            })
          );
          dispatch(setIsValidContactForm(false));
          dispatch(dispatchContactDetailsClient([]));
          if (selectedClient === 'Group') {
            getGroupDetails(e.data);
          } else if (selectedClient === 'Rebate Program Code') {
            getAllGroupByRebateProgramCode(e.data);
          } else if (selectedClient === 'Super Client') {
            onSuperCellClicked(e.data);
          } else {
            onCellClickedListener(e);
          }
        }}
        fullScreenView={fullScreenView}
        handleFullScreenViewClick={handleFullScreenView}
        navigateToNextCell={navigateToNextCell}
        tabToNextCell={tabToNextCell}
        enterMovesDown
        suppressCellFocus
        onCellFocused={onCellFocused}
        exportFile
        helpMessage={DOUBLE_CLICK_GRID_MSG}
        data-testid="onEditingStopped"
        fileName={selectedClient}
        gridHeight={fullScreenView ? 'auto' : 350}
      />
      {showViewHistory ? (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName="Code_Domain_Table"
          keyValue={keyValue}
        />
      ) : null}
    </div>
  );
};
export default withRouter(SearchClient);
